import { Box, ListItemAction, ListItemSection } from '@wix/design-system';
import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

import { AI_MODAL_PROMPT_LIST_ITEM } from '../data-hooks';
import { unreachable } from '../ts-utils';
import type { Prompt, PromptCollection } from '../types';
import styles from './ai-content-modal-scss';

type PromptsListProps = {
  visible: boolean;
  prompts: PromptCollection;
  highlightedIndex: number;
  onHighlight: (index: number) => void;
  onClick: (prompt: Prompt) => void;
};

export const PromptsList = React.forwardRef<HTMLDivElement, PromptsListProps>(
  ({ visible, prompts, highlightedIndex, onHighlight, onClick }, ref) => {
    const { t } = useContext(RicosContext);

    return (
      <Box
        className={classNames(styles.listWrapper, {
          [styles.visible]: visible,
        })}
      >
        <Box
          paddingTop="SP2"
          paddingBottom="SP2"
          direction="vertical"
          width="100%"
          height="100%"
          ref={ref}
        >
          {prompts.map((prompt, index) => {
            switch (prompt.type) {
              case 'prompt': {
                return (
                  <ListItemAction
                    dataHook={AI_MODAL_PROMPT_LIST_ITEM}
                    key={prompt.title}
                    title={t(prompt.title)}
                    size="small"
                    prefixIcon={prompt.icon ? <prompt.icon /> : <></>}
                    highlighted={highlightedIndex === index}
                    suffix={
                      highlightedIndex === index ? t('AIPlugin_PromptsList_Confirm_Suffix') : ''
                    }
                    onMouseEnter={() => onHighlight(index)}
                    onMouseLeave={() => onHighlight(-1)}
                    onClick={() => {
                      onClick(prompt);
                    }}
                  />
                );
              }
              case 'section': {
                return <ListItemSection key={prompt.title} title={t(prompt.title)} />;
              }
              default: {
                throw unreachable(prompt);
              }
            }
          })}
        </Box>
      </Box>
    );
  }
);
